// Header search (views/home/header.php) — Figma "Frame 49", Variant10: the
// magnifier opens a 311×43 field over "Ogłoszenia lokalne". The first click
// opens it; with text, the magnifier (or Enter) searches; empty, it closes.
// Escape and a click outside close it too. Without JS the button submits.

export function initNavSearch() {
  document.querySelectorAll('[data-nav-search]').forEach((form) => {
    const input = form.querySelector('input[type="search"]');
    const button = form.querySelector('button');
    if (!input || !button) return;

    const isOpen = () => form.classList.contains('is-open');

    const open = () => {
      form.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      input.tabIndex = 0;
      // Wait for the field to become visible before focusing it.
      requestAnimationFrame(() => input.focus());
    };

    const close = ({ restoreFocus = false } = {}) => {
      form.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      input.tabIndex = -1;
      if (restoreFocus) button.focus();
    };

    button.addEventListener('click', (event) => {
      if (!isOpen()) {
        event.preventDefault();
        open();
      } else if (!input.value.trim()) {
        event.preventDefault();
        // Enter in the field fires a synthetic click on this button (detail 0):
        // keep the field open for typing. A real pointer click closes it.
        if (event.detail > 0) close({ restoreFocus: true });
        else input.focus();
      }
    });

    form.addEventListener('submit', (event) => {
      if (!input.value.trim()) {
        event.preventDefault();
        if (isOpen()) input.focus();
        else open();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) close({ restoreFocus: true });
    });

    document.addEventListener('click', (event) => {
      if (isOpen() && !form.contains(event.target)) close();
    });
  });
}
